// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wo4c","toggle":"styles_toggle__3uLNL","preview":"styles_preview__23_OL"};